import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import PrintableLayout from './PrintableLayout.jsx';
import { SITE_URL } from '../../seo/siteConfig.js';
import heroDesktop from '../../assets/images/sumaira-and-emiliano-wedding/sumaira-emiliano-hero-desktop.webp';
import introBgDesktop from '../../assets/images/sumaira-and-emiliano-wedding/sumaira-emiliano-intro-bg-desktop.webp';
import venueCardDesktop from '../../assets/images/sumaira-and-emiliano-wedding/sumaira-emiliano-venue-card-desktop.webp';
import attireGuideDesktop from '../../assets/images/sumaira-and-emiliano-wedding/sumaira-emiliano-attire-guide-desktop.webp';
import bismillahArtwork from '../../assets/images/sumaira-and-emiliano-wedding/sumaira-emiliano-bismillah.svg';
import timelineRingsIcon from '../../assets/images/sumaira-and-emiliano-wedding/timeline-rings.svg';
import timelineReceptionIcon from '../../assets/images/sumaira-and-emiliano-wedding/timeline-reception.svg';
import timelineCameraIcon from '../../assets/images/sumaira-and-emiliano-wedding/timeline-camera.svg';
import timelineRingsPreviewIcon from '../../assets/images/sumaira-and-emiliano-wedding/timeline-rings-preview.svg';
import timelineReceptionPreviewIcon from '../../assets/images/sumaira-and-emiliano-wedding/timeline-reception-preview.svg';
import timelineCameraPreviewIcon from '../../assets/images/sumaira-and-emiliano-wedding/timeline-camera-preview.svg';
import logicaLogo from '../../assets/images/Logica (Black and White).webp';
import '../../styles/SumairaEmilianoPrintable.css';
import '../../styles/SumairaEmilianoPrintableOverrides.css';

const INVITATION_URL = `${SITE_URL}/invitations/custom/sumaira-cabrasan-bride-emiliano-ponce-groom-wedding`;
const MAP_URL = 'https://www.waze.com/en-GB/live-map/directions/villa-nilda-resort-vicente-ferriols-davao-city?to=place.w.82247750.822477501.7501309';
const FACEBOOK_URL = 'https://www.facebook.com/VillaNildaGardenResort';

const PARENTS_BRIDE = ['Jackeron Cabrasan', 'Hatima Cabrasan'];
const PARENTS_GROOM = ['Emiliano Ponce Sr.', 'Xochitl Ponce'];
const BELOVED_SONS = ['Yahya Nur Cabrasan', 'Fharhan Cabrasan'];

const PRINCIPAL_SPONSORS = [
  'Ms. Sitti Sahar M. Cabrasan',
  'Ms. Mieruah M. Vega',
  'Mrs. Sitti Maha V. Caddy',
  'Ms. Yoraideyl M. Macaraya',
  'Ms. Norhaney Macatabang',
  'Mrs. Indiana A. Cruz',
  'Mrs. Sana M. Aranggali',
  'Mrs. Rahma E. Payopas',
];

const FLOWER_GIRLS = [
  'Princess Dalal Bahide',
  'Al-Danah S. Navarro',
  'Sofia V. Macatabang',
  'Fadwa Rasay Sapilin',
];

const RING_BEARERS = ['Rashdan Zayn Caddy', 'Khalid M. Ando'];

const TIMELINE = [
  {
    time: '3:00 PM',
    title: 'Nikkah Ceremony',
    previewIcon: timelineRingsPreviewIcon,
    exportIcon: timelineRingsIcon,
  },
  {
    time: '4:00 PM',
    title: 'Reception',
    previewIcon: timelineReceptionPreviewIcon,
    exportIcon: timelineReceptionIcon,
  },
  {
    time: '5:00 PM',
    title: 'Pictorial',
    previewIcon: timelineCameraPreviewIcon,
    exportIcon: timelineCameraIcon,
  },
];

const REMINDERS = [
  {
    title: 'Invited Guests Only',
    text: 'Due to limited venue capacity, only guests specifically named on the invitation can be accommodated.',
  },
  {
    title: 'Adults-Only Celebration',
    text: 'We respectfully request an adults-only celebration so everyone may relax and enjoy the occasion.',
  },
  {
    title: 'Wedding Colors',
    text: 'Please wear semi-formal attire in Purple or Blush Pink to keep the celebration beautifully cohesive.',
  },
  {
    title: 'Arrival Time',
    text: 'Please arrive at least 30 minutes before the ceremony to allow enough time for seating.',
  },
  {
    title: 'Parking',
    text: 'Parking is available at Villa Nilda Garden Resort for attending guests.',
  },
  {
    title: 'Unplugged Moments',
    text: 'Please keep phones and cameras to a minimum during the ceremony and be fully present with us.',
  },
];

function PageChrome({ dark = false }) {
  return (
    <div className={`sep-chrome${dark ? ' sep-chrome--dark' : ''}`} aria-hidden="true">
      <span className="sep-corner sep-corner--tl" />
      <span className="sep-corner sep-corner--tr" />
      <span className="sep-corner sep-corner--bl" />
      <span className="sep-corner sep-corner--br" />
    </div>
  );
}

function FloralDivider({ light = false }) {
  return (
    <div className={`sep-divider${light ? ' sep-divider--light' : ''}`} aria-hidden="true">
      <span />
      <b>✦</b>
      <span />
    </div>
  );
}

function SectionHeading({ eyebrow, children, light = false }) {
  return (
    <header className={`sep-section-heading${light ? ' sep-section-heading--light' : ''}`}>
      {eyebrow && <p>{eyebrow}</p>}
      <h2>{children}</h2>
      <FloralDivider light={light} />
    </header>
  );
}

function NamePanel({ title, names, compact = false, style }) {
  return (
    <section className={`sep-name-panel${compact ? ' sep-name-panel--compact' : ''}`} style={style}>
      <h3>{title}</h3>
      <ul>
        {names.map((name) => <li key={name}>{name}</li>)}
      </ul>
    </section>
  );
}

function PrintableQr({ value, className = '' }) {
  return (
    <div className={`sep-qr-canvas-wrap${className ? ` ${className}` : ''}`}>
      <QRCodeCanvas
        value={value}
        size={256}
        bgColor="#fffafc"
        fgColor="#4a2e57"
        level="H"
        includeMargin
        style={{ display: 'block', width: '100%', height: '100%' }}
      />
    </div>
  );
}

function QrCard({ value, label, helper }) {
  return (
    <div className="sep-qr-card">
      <PrintableQr value={value} />
      <div>
        <strong>{label}</strong>
        <span>{helper}</span>
      </div>
    </div>
  );
}

export default function SumairaEmilianoPrintable() {
  return (
    <PrintableLayout
      title="Sumaira & Emiliano — Printable Nikkah Invitation (8 pages)"
      filename="sumaira-emiliano-nikkah-invitation"
    >
      <article
        className="pl-page sep-page sep-cover"
        aria-label="Cover page"
        style={{ backgroundImage: `url(${heroDesktop})` }}
      >
        <div className="sep-cover-overlay" aria-hidden="true" />
        <PageChrome dark />
        <div className="sep-cover-copy">
          <img
            className="sep-arabic-art"
            src={bismillahArtwork}
            alt="Bismillah ir-Rahman ir-Rahim"
          />
          <p className="sep-kicker sep-kicker--light">You are invited to the Nikkah of</p>
          <h1>Sumaira <span>&amp;</span> Emiliano</h1>
          <p className="sep-cover-subtitle">Two hearts, one promise, a union blessed by Allah</p>
          <FloralDivider light />
          <p className="sep-cover-date">Monday · August 3, 2026 · 3:00 PM</p>
          <p className="sep-cover-venue">Villa Nilda Garden Resort · Davao City</p>
          <p className="sep-hashtag">#SumOneForEmiliano</p>
        </div>
      </article>

      <article className="pl-page sep-page sep-invitation-page" aria-label="Invitation and celebration details">
        <div className="sep-paper-texture" aria-hidden="true" />
        <PageChrome />
        <div className="pl-content sep-content">
          <SectionHeading eyebrow="In the name of Allah, the Most Gracious, the Most Merciful">
            Together With Our Families
          </SectionHeading>

          <p className="sep-salaam">Assalamu Alaikum Warahmatullahi Wabarakatuh</p>
          <p className="sep-body sep-body--center">
            Under the divine grace of Allah (SWT), we joyfully invite you to witness and celebrate the
            Nikkah of <strong>Sumaira Cabrasan</strong> and <strong>Emiliano Ponce</strong>. Please keep us in
            your duas and grace us with your esteemed presence on this blessed day.
          </p>

          <div className="sep-detail-card">
            <div>
              <span>Date</span>
              <strong>Monday, August 3, 2026</strong>
            </div>
            <div>
              <span>Time</span>
              <strong>3:00 PM</strong>
            </div>
            <div>
              <span>Venue</span>
              <strong>Villa Nilda Garden Resort</strong>
            </div>
            <div>
              <span>Address</span>
              <strong>Vicente Ferriols, Davao City</strong>
            </div>
          </div>

          <div className="sep-parent-grid">
            <NamePanel title="Parents of the Bride" names={PARENTS_BRIDE} compact />
            <NamePanel title="Parents of the Groom" names={PARENTS_GROOM} compact />
          </div>

          <blockquote className="sep-quote">
            “And He placed between you affection and mercy.”
            <cite>Qur'an 30:21</cite>
          </blockquote>
        </div>
      </article>

      <article className="pl-page sep-page" aria-label="Wedding entourage">
        <div className="sep-paper-texture" aria-hidden="true" />
        <PageChrome />
        <div className="pl-content sep-content">
          <SectionHeading eyebrow="With the Blessings of Allah (SWT) and the Du'as of our Beloved Parents">
            Our Entourage
          </SectionHeading>

          <NamePanel
            title="Together with Our Beloved Sons"
            names={BELOVED_SONS}
            compact
            style={{ width: 'min(92mm, 72%)', margin: '0 auto 3mm', padding: '2.5mm 4mm' }}
          />

          <div className="sep-entourage-layout">
            <NamePanel title="Principal Sponsors" names={PRINCIPAL_SPONSORS} />
            <div className="sep-entourage-side">
              <NamePanel title="Flower Girls" names={FLOWER_GIRLS} compact />
              <NamePanel title="Ring Bearers" names={RING_BEARERS} compact />
              <div className="sep-blessing-card">
                <span>With grateful hearts</span>
                <p>
                  Thank you for standing with us as witnesses, guides, family, and friends as we begin our
                  married life together.
                </p>
              </div>
            </div>
          </div>
        </div>
      </article>

      <article className="pl-page sep-page sep-dress-code-page" aria-label="Dress code">
        <div className="sep-paper-texture" aria-hidden="true" />
        <PageChrome />
        <div className="pl-content sep-content">
          <SectionHeading eyebrow="Celebrate beautifully with us">Dress Code</SectionHeading>

          <section className="sep-dress-card sep-dress-card--standalone">
            <img src={attireGuideDesktop} alt="Semi-formal attire guide in purple and blush pink" />
            <div className="sep-dress-copy">
              <h3>Semi-Formal Attire</h3>
              <p>
                We kindly ask guests to wear only our wedding colors so the celebration and photographs
                feel beautifully cohesive.
              </p>
              <div className="sep-swatches" aria-label="Wedding colors">
                <span><i style={{ background: '#764A8D' }} />Purple</span>
                <span><i style={{ background: '#FFD4E3' }} />Blush Pink</span>
              </div>
            </div>
          </section>
        </div>
      </article>

      <article className="pl-page sep-page sep-timeline-page" aria-label="Wedding timeline">
        <div className="sep-paper-texture" aria-hidden="true" />
        <PageChrome />
        <div className="pl-content sep-content">
          <SectionHeading eyebrow="Be with us for every special moment">Wedding Timeline</SectionHeading>

          <section className="sep-timeline-card sep-timeline-card--standalone">
            <h3>Wedding Timeline</h3>
            <div className="sep-timeline">
              {TIMELINE.map((item) => (
                <div key={item.title} className="sep-timeline-item">
                  <span className="sep-timeline-number">
                    <img
                      className="sep-timeline-icon-image sep-timeline-icon-image--preview"
                      src={item.previewIcon}
                      alt=""
                      aria-hidden="true"
                      draggable="false"
                    />
                    <img
                      className="sep-timeline-icon-image sep-timeline-icon-image--export"
                      src={item.exportIcon}
                      alt=""
                      aria-hidden="true"
                      draggable="false"
                    />
                  </span>
                  <div>
                    <strong>{item.time}</strong>
                    <p>{item.title}</p>
                  </div>
                </div>
              ))}
            </div>
            <p className="sep-arrival-note">Please arrive by 2:30 PM for comfortable seating before the ceremony.</p>
          </section>
        </div>
      </article>

      <article className="pl-page sep-page sep-venue-page" aria-label="Venue and QR codes">
        <div className="sep-paper-texture" aria-hidden="true" />
        <PageChrome />
        <div className="pl-content sep-content">
          <SectionHeading eyebrow="Where we will celebrate">Villa Nilda Garden Resort</SectionHeading>

          <div className="sep-venue-image-wrap">
            <img src={venueCardDesktop} alt="Villa Nilda Garden Resort venue details" />
          </div>

          <div className="sep-venue-info">
            <div className="sep-venue-copy">
              <p className="sep-kicker">Venue</p>
              <h3>Villa Nilda Garden Resort</h3>
              <p>Vicente Ferriols, Davao City</p>
              <p className="sep-venue-note">
                Scan a QR code using your phone camera. The first opens directions, while the second opens
                the complete digital invitation.
              </p>
              <p className="sep-small-link">Venue page: {FACEBOOK_URL.replace('https://', '')}</p>
            </div>
            <div className="sep-qr-grid">
              <QrCard value={MAP_URL} label="Directions" helper="Open the venue in Waze" />
              <QrCard value={INVITATION_URL} label="Digital Invitation" helper="View RSVP and full details" />
            </div>
          </div>
        </div>
      </article>

      <article className="pl-page sep-page sep-celebrate-page" aria-label="RSVP, gift guide, and wedding information">
        <div
          className="sep-celebrate-bg"
          aria-hidden="true"
          style={{ backgroundImage: `url(${introBgDesktop})` }}
        />
        <div className="sep-celebrate-overlay" aria-hidden="true" />
        <PageChrome dark />
        <div className="pl-content sep-content sep-content--light">
          <SectionHeading eyebrow="Your presence is the sweetest gift" light>Celebrate With Us</SectionHeading>

          <div className="sep-celebrate-grid">
            <section className="sep-glass-card">
              <span className="sep-glass-label">RSVP</span>
              <h3>Kindly reply by July 23, 2026</h3>
              <p>
                Please confirm through the RSVP form in our digital invitation. For direct concerns, you may
                email us at <strong>scabrasan@gmail.com</strong>.
              </p>
              <div className="sep-inline-qr">
                <PrintableQr value={INVITATION_URL} className="sep-inline-qr-canvas-wrap" />
                <span>Scan to RSVP</span>
              </div>
            </section>

            <section className="sep-glass-card">
              <span className="sep-glass-label">Gift Guide</span>
              <h3>Your presence means the most</h3>
              <p>
                Your presence at our Nikkah is the most meaningful gift of all. Should you wish to honour us
                with another gift, a monetary contribution toward our future would be sincerely appreciated.
              </p>
              <div className="sep-hashtag-card">
                <span>Share the love</span>
                <strong>#SumOneForEmiliano</strong>
              </div>
            </section>
          </div>

          <p className="sep-dua">
            May Allah bless our union, place love and mercy between our hearts, and surround this new chapter
            with peace, faith, and joy.
          </p>
        </div>
      </article>

      <article className="pl-page sep-page sep-reminders-page" aria-label="Kind reminders and closing message">
        <div className="sep-paper-texture" aria-hidden="true" />
        <PageChrome />
        <div className="pl-content sep-content">
          <SectionHeading eyebrow="A few thoughtful notes for our guests">Kind Reminders</SectionHeading>

          <div className="sep-reminder-grid">
            {REMINDERS.map((reminder, index) => (
              <section className="sep-reminder" key={reminder.title}>
                <span>{String(index + 1).padStart(2, '0')}</span>
                <div>
                  <h3>{reminder.title}</h3>
                  <p>{reminder.text}</p>
                </div>
              </section>
            ))}
          </div>

          <div className="sep-closing">
            <p className="sep-kicker">With love and gratitude</p>
            <h2>Sumaira &amp; Emiliano</h2>
            <p>We cannot wait to celebrate this blessed beginning with you.</p>
            <div className="sep-logica">
              <span>Digital invitation by</span>
              <img src={logicaLogo} alt="Logica" />
              <strong>Logica</strong>
            </div>
          </div>
        </div>
      </article>
    </PrintableLayout>
  );
}
